import React, { useEffect, useRef, useState } from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export default function UserAccessProjectBadges(_ref) {
  let {
    userAccess,
    maxNumberOfBadgesAllowed = 2,
    maxProjectNameLengthLimit = 20
  } = _ref;
  const {
    t
  } = useTranslation();
  const hasReachedMaximumNumberOfBadges = useRef(true);
  useEffect(() => {
    hasReachedMaximumNumberOfBadges.current = userAccess.user_access_project_participations.length > maxNumberOfBadgesAllowed;
  }, [userAccess, maxNumberOfBadgesAllowed]);
  const projectBadge = participation => {
    const lengthIsLongerThanLimit = participation.claim_project_report.project_name.length > maxProjectNameLengthLimit;
    return /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: 'top',
      placement: 'top',
      overlay: lengthIsLongerThanLimit ? /*#__PURE__*/React.createElement(Tooltip, {
        id: `tooltip-${'top'}`,
        show: false
      }, /*#__PURE__*/React.createElement("div", null, participation.claim_project_report.project_name)) : /*#__PURE__*/React.createElement("div", null)
    }, /*#__PURE__*/React.createElement(Badge, {
      key: userAccess.user.email,
      bg: "primary",
      className: "me-2"
    }, lengthIsLongerThanLimit ? participation.claim_project_report.project_name.slice(0, 10) + '...' : participation.claim_project_report.project_name));
  };
  if (!userAccess?.user_access_project_participations?.length) return /*#__PURE__*/React.createElement(React.Fragment, null);
  const badges = hasReachedMaximumNumberOfBadges.current ? userAccess.user_access_project_participations.slice(0, maxNumberOfBadgesAllowed).map((participation, index) => {
    return projectBadge(participation);
  }) : userAccess.user_access_project_participations.map((participation, index) => {
    return projectBadge(participation);
  });
  const restToolTip = /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: 'top',
    placement: 'top',
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: `tooltip-${'top'}`
    }, /*#__PURE__*/React.createElement("div", null, userAccess.user_access_project_participations.slice(maxNumberOfBadgesAllowed).map(p => p.claim_project_report.project_name).join(' | ')))
  }, /*#__PURE__*/React.createElement(Badge, {
    key: userAccess.user.email,
    bg: "dark"
  }, "...", t('rest')));
  return /*#__PURE__*/React.createElement(React.Fragment, null, badges, hasReachedMaximumNumberOfBadges.current && restToolTip);
}